<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="inpBox box">
          <template v-for="column in tabHeadList" >
            <template v-if="column.isSettingQuery==1">
              <el-form-item label="运单编号:" class="item1" v-if="column.enName=='wayNo'" :key="column.enName">
                <el-input placeholder="" type="textarea" v-model="searchFrom.wayNo" class="gjh"></el-input>
              </el-form-item>
              <el-form-item label="结算客户:" v-else-if="column.enName=='payee'" :key="column.enName">
                <el-select  v-model="searchFrom.payee" filterable placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货物类型:" v-else-if="column.enName=='productTypeName'" :key="column.enName">
                <el-select  v-model="searchFrom.productTypeName" filterable placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in HWlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="司机归属:"  v-else-if="column.enName=='driverOwnershipName'" :key="column.enName">
                <el-select v-model="searchFrom.driverOwnershipName" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="自有" value="自有" ></el-option>
                  <el-option label="外协" value="外协" ></el-option>
                </el-select>
              </el-form-item>
             <el-form-item label="承运商:"  v-else-if="column.enName=='payer'" :key="column.enName">
                <el-select  v-model="searchFrom.payer" filterable placeholder="请选择" >
                  <el-option v-for="item in cysList" :label="item.companyName" :value="item.companyName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运单状态:" v-else-if="column.enName=='wayStateName'" :key="column.enName">
                <el-select v-model="searchFrom.wayStateArr"  multiple placeholder="请选择">
                  <!-- <el-option label="全部" value="" ></el-option> -->
                  <el-option label="待配载" value="0" ></el-option>
                  <el-option label="待装车" value="1" ></el-option>
                  <el-option label="运输中" value="2" ></el-option>
                  <el-option label="待签收" value="3" ></el-option>
                  <el-option label="已签收" value="4" ></el-option>
                  <el-option label="已作废" value="5" ></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="创建时间:" class="item2" v-else-if="column.enName=='createTime'" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.createTimes"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="实际签收时间:" class="item2" v-else-if="column.enName=='actualSigningTime'" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.actualSigningTime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item :label="column.cnName+':'" v-else :key="column.enName">
                <el-input placeholder="" v-model="searchFrom[column.enName]" ></el-input>
              </el-form-item>
            </template>
          </template>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary"  v-if="btnFlg[1]" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" v-if="btnFlg[2]" @click="exportFn" size="mini" :disabled="isDisable">导出</el-button>
          </div>
          <div @click="tabSetting"><i class="el-icon-s-tools"></i></div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
       <el-table-column type="selection" width="55"></el-table-column>
       <el-table-column  type="index" width="55" label="序号"></el-table-column>
        <template v-for="column in tabHeadList">
          <template v-if="column.enName=='wayNo'">
            <el-table-column property="" :formatter="formatterRowEmpty" width="240" label="运单编号" :key="column.enName">
              <template slot-scope="scope">
                <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.wayNo}}</span>
              </template>
            </el-table-column>
          </template>
           <template v-else-if="column.enName=='weightDifferenceRate'">
            <el-table-column property=""  width="100" label="磅差率(‰)" :key="column.enName">
              <template slot-scope="scope">
                <span  v-if="(-3<scope.row.weightDifferenceRate)&&(scope.row.weightDifferenceRate<3)" >{{scope.row.weightDifferenceRate}}</span>
                <span style="color: #D51212;" v-else >{{scope.row.weightDifferenceRate?scope.row.weightDifferenceRate:'-'}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='wayStateName'">
            <el-table-column property="" :formatter="formatterRowEmpty" width="100" label="状态" :key="column.enName">
              <template slot-scope="scope">
                <span style="color: #E99D42;" v-if="scope.row.wayState==2" >{{scope.row.wayStateName}}</span>
                <span style="color: #D51212;" v-else-if="scope.row.wayState==3" >{{scope.row.wayStateName}}</span>
                <span style="color: #81B337;" v-else-if="scope.row.wayState==4" >{{scope.row.wayStateName}}</span>
                <span style="color: #9A9A9A;" v-else-if="scope.row.wayState==5" >{{scope.row.wayStateName}}</span>
                <span  v-else >{{scope.row.wayStateName}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-else>
           <el-table-column :key="column.enName" :prop="column.enName" :label="column.cnName" :width="column.fieldWidth" show-overflow-tooltip :formatter="formatterRowEmpty">
              <template v-for="item in column.child">
                <el-table-column property="" v-if="item.enName=='revenueSurcharge'"  width="150" label="收入附加费(元)" :key="item.enName">
                  <template slot-scope="scope">
                    <span style="color: #81B337;" v-if="scope.row.revenueSurcharge>0" >{{scope.row.revenueSurcharge}}</span>
                    <span style="color: #D51212;" v-else-if="scope.row.revenueSurcharge<0" >{{scope.row.revenueSurcharge}}</span>
                    <span v-else >{{scope.row.revenueSurcharge?scope.row.revenueSurcharge:'-'}}</span>
                  </template>
                </el-table-column>
                <el-table-column property="" v-else-if="item.enName=='disburseSurcharge'"  width="150" label="支出附加费(元)" :key="item.enName">
                  <template slot-scope="scope">
                    <span style="color: #81B337;" v-if="scope.row.disburseSurcharge>0" >{{scope.row.disburseSurcharge}}</span>
                    <span style="color: #D51212;" v-else-if="scope.row.disburseSurcharge<0" >{{scope.row.disburseSurcharge}}</span>
                    <span v-else >{{scope.row.disburseSurcharge?scope.row.disburseSurcharge:'-'}}</span>
                  </template>
                </el-table-column>
                <el-table-column v-else :key="item.enName" :prop="item.enName" :label="item.cnName" :width="item.fieldWidth" show-overflow-tooltip :formatter="formatterRowEmpty">
                </el-table-column>
              </template>
            </el-table-column>
          </template>
        </template>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <!-- 导入 -->
    <importC   v-if="importDialog" :importDialog.sync="importDialog"></importC>
    <!-- 装卸凭证 -->
    <zhuangxiupinzheng v-if="pingzhengFlag" :rowData="goodform" :pingzhengFlag.sync="pingzhengFlag"></zhuangxiupinzheng>
    <!-- 作废 -->
    <el-dialog  title="作废" :close-on-click-modal="false" :close-on-press-escape="false"  @close="ZFflag = false"  :visible.sync="ZFflag" width="400px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  :model="ZFform"  class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="作废原因" class="item1" prop="causeCancellation">
            <el-input placeholder="" type="textarea" maxlength="100" v-model="ZFform.causeCancellation" class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ZFflag = false">取 消</el-button>
        <el-button type="primary" @click="ZFsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
     <!-- 配车 -->
    <el-dialog  title="配车" :close-on-click-modal="false" :close-on-press-escape="false"  @close="peicheFlag = false"  :visible.sync="peicheFlag" width="900px" center>
      <div>
        <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline" label-width="90px" size="mini">
          <peiche :goodform="goodform" v-if="peicheFlag"></peiche>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="peicheFlag = false">取 消</el-button>
        <el-button type="primary" @click="PCsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 附件 -->
    <el-dialog  title="附件" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="fujianFlag" width="500px" center>
      <div class="fujianBox">
         <el-button type="text" v-for="item in fujianList" @click="fujianClick(item)" :key="item.id">{{item.name}}</el-button>
      </div>
      <el-dialog  title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag"
        append-to-body width="800px" center>
        <div style="text-align: right;">
          <el-button type="primary" @click="dayinImgFn">打印</el-button>
          <div id="printMe"  ref="print">
            <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
     <!-- 设置表头 -->
    <table-heads v-if="tableMark" :tableMark.sync='tableMark' :groupCode="groupCode" @refresh = 'queryMyPageField'></table-heads>
    <export-setting v-if="exportMark" :exportMark.sync='exportMark' :groupCode="groupCode"
   @exportList='exportList'></export-setting>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, dateFormat1, getLastMonth } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import importC from '@/views/newTMS/publicFiles/wayManage/daoru.vue'
import zhuangxiupinzheng from '@/views/newTMS/publicFiles/wayManage/zhuangxiupinzheng.vue'
import peiche from '@/views/newTMS/publicFiles/wayAndOrder/peiche.vue'
import tableHeads from '@/views/newTMS/publicFiles/tableHeades.vue'
import exportSetting from '@/views/newTMS/publicFiles/exportSetting.vue'
import { getDictionaryDetailList, queryMyPageField, findWayList, voidWay, findWayFiles, distributeCar,
  findCustomerInfoList } from '@/api/newTMS'
import { selectTenantCompanyListByTenantCode } from '@/api/newCrm'
export default {
  components: {
    importC, zhuangxiupinzheng, tableHeads, exportSetting, peiche
  },
  data () {
    return {
      groupCode: 'customerWay',
      tableMark: false,
      exportMark: false,
      tabHeadList: [],
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        orderNo: this.$route.query.orderNo
      },
      total: 0,
      loading: false,
      isDisable: false,
      importDialog: false,
      pingzhengFlag: false,
      moneyDialog: false,
      fujianFlag: false,
      fujianList: [],
      lookImgFlag: false,
      imgUrl: '',
      rules: {
        // publishPricingMethod: [
        //   { required: true, message: '请选择计价方式', trigger: 'blur' }
        // ],
        // pricingMethod: [
        //   { required: true, message: '请选择计价方式', trigger: 'blur' }
        // ],
        // unitPrice: [
        //   { required: true, message: '请输入价格', trigger: 'blur' }
        // ],
        causeCancellation: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ]
      },
      kehuList: [],
      HWlist: [],
      goodform: {},
      list: [
        { name: '订单编号' },
        { name: '收入', child: [{ name: '收入总额' }] },
        { name: '支出', child: [{ name: '支出总额' }] }
      ],
      wayBusinessId: '',
      ZFflag: false,
      ZFform: {},
      peicheFlag: false,
      cysList: [],
      btnFlg: [],
      btnIdArr: ['01N0120100', '01N0120200', '01N0120300']

    }
  },
  created () {
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
    this.btnFlg = getBtn(this.btnIdArr, '/customerWay')
    findCustomerInfoList({ businessType: 1 }).then(res => { this.kehuList = res })
    selectTenantCompanyListByTenantCode({ tenantCode: localStorage.getItem('tenantCode'), businessCodes: this.global.businessCodeYS }).then(res => {
      this.cysList = res
    })
    this.$set(this.searchFrom, 'createTimes', getLastMonth())
    this.searchFn(this.searchFrom)
    this.queryMyPageField()
  },
  mounted () {

  },
  methods: {
    // 配车
    peicheFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].wayState !== 0) {
        this.$alert('运单不是待配载状态，不能配车', '系统提示')
        return
      }
      this.goodform.wayIds = [selectData[0].wayId]
      this.peicheFlag = true
    },
    PCsaveFn () {
      if (!this.goodform.driverId) {
        this.$alert('请选择司机', '系统提示')
        return false
      }
      if (!this.goodform.plateNumber) {
        this.$alert('请选择车辆', '系统提示')
        return false
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      distributeCar(this.goodform).then(res => {
        loading.close()
        this.peicheFlag = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 打印
    dayinFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        this.$router.push({ name: 'tmsWayDayin', query: { id: selectData[0].wayBusinessId } })
      }
    },
    // 附件
    fujianFn (row) {
      findWayFiles({ wayId: row.wayId }).then(res => {
        if (res.length == 0) {
          this.$alert('此运单没有附件', '系统提示')
        } else {
          this.fujianFlag = true
          this.fujianList = []
          res.forEach(item => {
            var filename = item.url.split('/').pop()
            this.fujianList.push({
              name: filename,
              url: item.fileKeyUrl
            })
          })
        }
      })
    },
    fujianClick (row) {
      if (this.isImage(row.name)) {
        this.lookImgFlag = true
        this.imgUrl = row.url
      } else {
        window.open(row.url)
      }
    },
    dayinImgFn () {
      this.$print(this.$refs.print)
    },
    isImage (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },
    // 详情
    detailFn (row) {
      this.$router.push({ name: 'customerWayDetails', query: { id: row.wayBusinessId } })
    },
    // 作废
    zuofeiFn (row) {
      this.ZFflag = true
      this.ZFform = {}
      this.ZFform.wayId = row.wayId
      this.ZFform.wayBusinessId = row.wayBusinessId
    },
    ZFsaveFn () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      voidWay(this.ZFform).then(res => {
        loading.close()
        this.ZFflag = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    tabSetting () {
      this.tableMark = true
    },
    // 查询我的页面表头
    queryMyPageField () {
      queryMyPageField({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        tagCode: this.groupCode
      }).then(res => {
        this.tabHeadList = res
        this.$nextTick(() => {
          let h = this.$refs.searchBox.offsetHeight
          let pH = document.documentElement.clientHeight
          this.h = (pH - h - 98) + 'px'
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 打印
    dayinFn () {

    },
    // 装卸凭证
    pingzhengFn (row) {
      this.goodform = { ...row }
      this.pingzhengFlag = true
    },
    exportList (val) {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      exportExcel(
        this.global.tmsPlus + '/way/exportWayList',
        form,
        '运单列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 导出
    exportFn () {
      this.exportMark = true
    },
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/crm/CRM3.0%E5%AE%A2%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'// 后更改页面地址
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      if (this.searchFrom.wayNo) {
        this.searchFrom.wayNos = this.searchFrom.wayNo.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.cargoBarcode) {
        this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.actualSigningTime) {
        this.searchFrom.actualSigningTimeStart = this.searchFrom.actualSigningTime[0]
        this.searchFrom.actualSigningTimeEnd = this.searchFrom.actualSigningTime[1]
      } else {
        this.searchFrom.actualSigningTimeStart = ''
        this.searchFrom.actualSigningTimeEnd = ''
      }
      if (this.searchFrom.wayStateArr) {
        this.searchFrom.wayStates = this.searchFrom.wayStateArr.toString()
      } else {
        this.searchFrom.wayStates = ''
      }
      this.loading = true
      findWayList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.$set(this.searchFrom, 'createTimes', getLastMonth())
    },
    closeDialog () {
      this.$refs['SQFrom'].clearValidate()
      this.SQFrom = {
      }
    }
  },
  activated () {
    this.getList(this.searchFrom)
  },
  inject: ['reload'],
  beforeRouteEnter (to, from, next) {
    to.meta.keepAlive = true
    // if (from.path != '/customerWay/details') {
    //   next(vm => {
    //     vm.reload()
    //   })
    // } else {
    //   next()
    // }
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (to.path == '/customerWay/details') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width: 430px!important;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
.fujianBox{
  display: flex;
  flex-direction: column;
  /deep/.el-button--text{
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
/deep/.el-form{
  width: 100%;
}
.box{
  width: 100%;
   display: grid;
   grid-template-columns: repeat(auto-fill, 280px);
   grid-auto-flow: row dense;
   /deep/.el-textarea__inner{
    width: 150px;
    height: 68px;
   }
   .item1{
      grid-row-start: span 2;
    }
   .item2{
      grid-column-start: span 2;
      width: 540px;
   }
}

</style>
